module.exports = __webpack_public_path__ + "img/jebsen.9f5ed12c.png";